import DisclaimersButton from './DisclaimersButton'
import DisclaimersButtonContainer from './DisclaimersButtonContainer'

export default DisclaimersButtonContainer(DisclaimersButton)
